import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
} from "react-google-maps";
import {
  compose,
  withProps,
  withStateHandlers,
} from "recompose";
import Spinner from "views/lib/components/Spinner";
import MapMarker from "./map-marker";
import { GOOGLE_MAP_URL } from "../../../../../constants";

const MapComponent = compose(
  withProps({
    googleMapURL: GOOGLE_MAP_URL,
    loadingElement: <Spinner/>,
    containerElement: <div style={{
      // height: "calc(100vh - 140px)",
      height: "100%",
      position: "relative"
    }}/>,
    mapElement: <div className="h-100"/>,
    center: {
      lat: 40.177200,
      lng: 44.503490
    },
  }),
  withStateHandlers(() => ({
    isOpen: false,
  }), {
    onToggleOpen: ({ isOpen }) => () => ({
      isOpen: !isOpen,
    })
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={16}
    defaultCenter={props.defaultCenter}
    center={props.center && props.center}
    zoom={props.zoom && props.zoom}
  >
    {/* <Zone/> */}
    <div className="onMapInfo">{props.handleShowInfo()}</div>
    {/* eslint-disable-next-line array-callback-return */}
    {props.markers && props.markers
      .map((item) => {
        if (!item.location
          || !item.location.longitude
          || !item.location.latitude) {
          return null;
        }
        const id = item.id;
        return (
          <MapMarker
            key={id}
            item={item}
            isSelected={id === props.selectedId}
            {...props}
          />
        );
      })}
  </GoogleMap>
));

export default MapComponent;



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/map/googleMap.js